module.exports = __webpack_public_path__ + "images/handheld-09fe875915a3c09d0387c61193b2757f.png";